import {css} from "lit";
import {commonStyles} from "./Common.js";
import {iconStyles} from "./Icons.js";
import {iconButtonStyles} from "../controls-inputs/IconButton.styles.js";
import {labeledTextInputStyles} from "../controls-inputs/LabeledTextInput.styles.js";
import {customScrollStyles} from "./CustomScrollBar.js";

export const modalStyles = [commonStyles, customScrollStyles, iconStyles, iconButtonStyles, labeledTextInputStyles, css`
	.pico-content {
		background-color: var(--pn-modal-content-bg);
		border: 1px solid var(--pn-modal-content-border-color);
		.m-box-shadow (0 3px 9px var(--pn-modal-shadow-color));
		background-clip: padding-box;
		outline: 0;
		font-family: var(--pn-font-family-base);
		overflow-x: hidden;
		overflow-y: auto; /* Allow scrolling on smaller screens */
	}

	.modal-content {
		display: flex;
		gap: 15px;
		min-height: 200px;
		min-width: 200px;
	}

	#pn-modal-logo img {
		width: 40px;
		margin-top: 10px;
	}

	#pn-modal-content {
		flex: 1;
		display: flex;
		flex-direction: column;
	}

	#pn-modal-logo + #pn-modal-content {
		margin-bottom: 14px;
	}

	#modal-confirm {
		height: auto;
	}

	h2 {
		margin: 13px 0 28px;
		padding: 0;
		color: var(--pn-modal-title-color);
		font-family: var(--pn-headings-font-family);
		font-size: (var(--pn-font-size-large + 8));
		font-weight: 500;
		line-height: 1.4;
		border-bottom: none;
	}
	.subtitle {
		margin-bottom: 30px;
		color: var(--pn-modal-text-color);
		font-size: var(--pn-font-size-large);
		line-height: 1.35;
	}

	form {
		display: flex;
		flex-direction: column;
		flex: 1;
	}

	form .aa-form-group.expand {
		display: flex;
		flex-direction: column;
		flex: 1;
	}

	.aa-form-group.expand textarea {
		min-height: 44px;
		flex: 1 44px;
		resize: none;
	}

	/** Multiple buttons **/
	.multiple-btn {
		margin-top: 30px;
		text-align: center;
	}

	.multiple-btn pn-button {
		margin: 0 25px;
	}

	.padded-modal {
		display: flex;
		flex-direction: column;
		height: 100%;
		box-sizing: border-box;
		padding: var(--pn-modal-inner-padding);
	}

	/** Close button **/
	.pico-close {
		position: absolute;
		top: 18px;
		right: 18px;
		z-index: (var(--pn-zindex-modal + 20));
		// Some extra padding to make it look nicer when focused
		padding: 3px;
		margin: -3px;
		background-color: var(--pn-btn-icon-bg);
		border-color: transparent;
		// .dotted-focus-outline();
		
	}

	.pico-close .icon-close {
		font-size: var(--pn-font-size-large);
	}

	.pico-content.showing {
		animation: fadeIn 0.3s;
	}

	@keyframes fadeIn {
		0% {opacity: 0}
		100% {opacity: 1}
	}

	/**
	 * Basic modal
	 */
	.basic-modal-content {
		position: relative;
		background-color: @modal-content-bg;
		border-radius: 6px;
		background-clip: padding-box;
		outline: 0;
		padding: 30px 40px 35px;
	}

	.basic-modal-content .heading h2 {
		padding: 0;
		margin-bottom: 28px;
		font-weight: 500;
	}

	.basic-modal-content .heading h2 #pn-modal-logo {
		display: inline-block;
		vertical-align: middle;
		line-height: 26px;
		margin-right: 10px;
	}

	.basic-modal-content .heading h2 #pn-modal-logo img {
		margin: 0;
	}

	.basic-modal-content .body {
		font-size: (@font-size-large + 2);
		line-height: 25px;
	}
	.basic-modal-content .body textarea.form-control {
		padding: 13px;
		resize: vertical;
	}

	.basic-modal-content .body a {
		font-size: inherit;
	}

	.basic-modal-content .body .long { /* e.g. "terms of use", which will probably need to scroll */
		min-height: 300px;
		max-height: calc(100vh - 650px);
		overflow: auto;
		// @media (max-width: @screen-xs-max) {
		// 	max-height: calc(100vh - 370px);
		// }
		// @media (min-width: @screen-sm-min) and (max-width: @screen-md-max) and (orientation: portrait) {
		// 	max-height: calc(100vh - 700px);
		// }
	}

	.basic-modal-content .buttons {
		margin-top: 30px;
		text-align: center;
	}
	.basic-modal-content .buttons button {
		margin: 0 25px;
	}

	.basic-modal-content .footer {
		margin-top: 40px;
		font-size: 15px;
	}

	.basic-modal-content .footer ::part(button) {
		font-size: inherit;
	}

	.basic-modal-content .footer .link {
		display: inline-block;
		text-decoration: underline;
	}

	.basic-modal-content .footer p {
		margin-bottom: 0px;
	}

	.modal-error-msg, .modal-success-msg {
		margin: 1em 0 0 0;
	}

	.modal-error-msg {
		font-size: 14px;
	}

	.modal-success-msg {
		font-size: 14px;
	}

	/* TODO: move specific modal styles elsewhere */
	#int-login {
	}

	#create-project {
		width: 500px;
		min-height: 400px;
	}
`];
